import script from "./CurriculumList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurriculumList.vue?vue&type=script&setup=true&lang=ts"

import "./CurriculumList.vue?vue&type=style&index=0&id=6c39ebf9&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c39ebf9"]])

export default __exports__